import { useEffect, useState } from 'react';
import './admin-settings.css';
import { HashLoader } from 'react-spinners';
import ToastNotification, { showToast } from '../../components/toasts/ToastNotification';
import { getSettings, updateSettings, updateTermOfService, updatePrivacyPolicy } from '../../api/settings.api';
import { testTelegramOrderMessage } from '../../api/telegram.api';

export const AdminSettings = () => {
  const [settings, setSettings] = useState({});
  const [term, setTerm] = useState([]);
  const [privacy, setPrivacy] = useState([]);

  const [termText, setTermText] = useState('');
  const [privacyText, setPrivacyText] = useState('');

  const [loading, setLoading] = useState(false);
  const [testingTelegram, setTestingTelegram] = useState(false);

  const [rawJson, setRawJson] = useState('');
  const [configJsonError, setConfigJsonError] = useState('');
  const [termJsonError, setTermJsonError] = useState('');
  const [privacyJsonError, setPrivacyJsonError] = useState('');


  useEffect(() => {
    fetchSettings();
    document.title = 'Admin - Cài đặt Website';
  }, []);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const res = await getSettings();
      if (res.success && res.data?.settings?.config) {
        const parsedSettings = JSON.parse(res.data.settings.config);
        setSettings(JSON.parse(res.data.settings.config));
        setRawJson(JSON.stringify(parsedSettings, null, 2));
        setTerm(res.data.settings.term_of_service);
        setPrivacy(res.data.settings.privacy_policy);

        setTermText(JSON.stringify(res.data.settings.term_of_service, null, 2));
        setPrivacyText(JSON.stringify(res.data.settings.privacy_policy, null, 2));
        setConfigJsonError('');
        setTermJsonError('');
        setPrivacyJsonError('');
      } else {
        showToast("Không tìm thấy cấu hình", "error");
      }
    } catch (error) {
      showToast(error.message || "Lỗi khi tải cấu hình", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateSettings = async () => {
    setLoading(true);
    try {
      const res = await updateSettings(settings);
      if (res.success) {
        showToast("Cập nhật thành công", "success");
        fetchSettings();
      } else {
        showToast("Cập nhật thất bại", "error");
      }
    } catch (error) {
      showToast(error.message || "Lỗi khi cập nhật", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateTerm = async () => {
    setLoading(true);
    try {
      const res = await updateTermOfService(term);
      if (res.success) {
        showToast("Cập nhật thành công", "success");
        fetchSettings();
      } else {
        showToast("Cập nhật thất bại", "error");
      }
    } catch (error) {
      showToast(error.message || "Lỗi khi cập nhật", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdatePrivacy = async () => {
    setLoading(true);
    try {
      const res = await updatePrivacyPolicy(privacy);
      if (res.success) {
        showToast("Cập nhật thành công", "success");
        fetchSettings();
      } else {
        showToast("Cập nhật thất bại", "error");
      }
    } catch (error) {
      showToast(error.message || "Lỗi khi cập nhật", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleTestTelegram = async () => {
    setTestingTelegram(true);
    try {
      const res = await testTelegramOrderMessage();
      if (res?.success) {
        showToast("Đã gửi tin nhắn test Telegram", "success");
      } else {
        showToast("Gửi test Telegram thất bại", "error");
      }
    } catch (error) {
      showToast(error.message || "Lỗi khi test Telegram", "error");
    } finally {
      setTestingTelegram(false);
    }
  };

  if (loading) {
    return (
      <div className="loader-container">
        <HashLoader color="var(--hash-loader-color)" />
      </div>
    );
  }

  return (
    <section className='admin-site-settings-page'>
      <ToastNotification />
      <div className='admin-site-settings-shell'>
        <header className='admin-site-settings-head'>
          <div>
            <p className='admin-site-settings-breadcrumb'>Quản trị / Cài đặt</p>
            <h1 className='admin-site-settings-title'>Cài đặt Website</h1>
          </div>
          <div className='admin-site-settings-actions'>
            <button
              onClick={handleTestTelegram}
              disabled={loading || testingTelegram}
              className='admin-site-settings-btn admin-site-settings-btn-secondary'
              type='button'
            >
              {testingTelegram ? "Đang gửi..." : "Test Telegram Order"}
            </button>
          </div>
          <div className='admin-site-settings-kpi'>
            <div className='admin-site-settings-kpi-item'>
              <span>Site Config</span>
              <strong>JSON</strong>
            </div>
            <div className='admin-site-settings-kpi-item'>
              <span>Term Of Service</span>
              <strong>Array</strong>
            </div>
            <div className='admin-site-settings-kpi-item'>
              <span>Privacy Policy</span>
              <strong>Array</strong>
            </div>
          </div>
        </header>

        <div className='admin-site-settings-grid'>
          <section className='admin-site-settings-card'>
            <h3 className='admin-site-settings-card-title'>Cấu hình Site</h3>
            <p className='admin-site-settings-card-subtitle'>Dạng dữ liệu: JSON object</p>
            <textarea
              className='admin-site-settings-editor'
              rows="14"
              value={rawJson}
              onChange={(e) => {
                const newValue = e.target.value;
                setRawJson(newValue);

                try {
                  const parsed = JSON.parse(newValue);
                  setSettings(parsed);
                  setConfigJsonError('');
                } catch {
                  setConfigJsonError('JSON không hợp lệ');
                }
              }}
            />
            {configJsonError && <p className='admin-site-settings-error'>{configJsonError}</p>}
            <button
              onClick={handleUpdateSettings}
              disabled={loading || !!configJsonError}
              className='admin-site-settings-btn'
            >
              Cập nhật
            </button>
          </section>

          <section className='admin-site-settings-card'>
            <h3 className='admin-site-settings-card-title'>Điều khoản dịch vụ</h3>
            <p className='admin-site-settings-card-subtitle'>Dạng dữ liệu: JSON array</p>
            <textarea
              className='admin-site-settings-editor'
              rows="14"
              value={termText}
              onChange={(e) => {
                setTermText(e.target.value);
                try {
                  setTerm(JSON.parse(e.target.value));
                  setTermJsonError('');
                } catch {
                  setTermJsonError('JSON array không hợp lệ');
                }
              }}
            />
            {termJsonError && <p className='admin-site-settings-error'>{termJsonError}</p>}
            <button
              onClick={handleUpdateTerm}
              disabled={loading || !!termJsonError}
              className='admin-site-settings-btn'
            >
              Cập nhật
            </button>
          </section>

          <section className='admin-site-settings-card'>
            <h3 className='admin-site-settings-card-title'>Chính sách bảo mật</h3>
            <p className='admin-site-settings-card-subtitle'>Dạng dữ liệu: JSON array</p>
            <textarea
              className='admin-site-settings-editor'
              rows="14"
              value={privacyText}
              onChange={(e) => {
                setPrivacyText(e.target.value);
                try {
                  setPrivacy(JSON.parse(e.target.value));
                  setPrivacyJsonError('');
                } catch {
                  setPrivacyJsonError('JSON array không hợp lệ');
                }
              }}
            />
            {privacyJsonError && <p className='admin-site-settings-error'>{privacyJsonError}</p>}
            <button
              onClick={handleUpdatePrivacy}
              disabled={loading || !!privacyJsonError}
              className='admin-site-settings-btn'
            >
              Cập nhật
            </button>
          </section>
        </div>
      </div>
    </section>
  );
};
